// import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import "./assets/scss/main.scss";
import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { ProtectedRoute } from "./reauseble";
import { Header, Footer } from "./header-footer";
import {
	Home,
	About,
	Shop,
	Singleproduct,
	Faq,
	Contact,
	Wishlist,
	Checkout,
	Cart,
	Orderdetail,
	Error,
	Orderhistory,
	SingleDeal,
	Userprofile,

	LegalnRegInfo,
	Learning,
	EService,
	LegalnRegInfoCat,
	DirectorshipApplication,
	DirectorshipApplicationCat,
	NewsFeeds,
	NewsFeedsDetails,
	Courses,
	ShareHolders,
	LegalnRegInfoCatDetails,
	MyApplication,
	WebinarsandEvents,
	PICGPodcast,
	Presentation,
	GovernanceUpdate,
	Announcements,
	Proceeding,
	EVoting
} from "./pages/js";
import {
	Loginform,
	Createnewpass,
	Forgotpassword,
	Registerform,
	Verifyemail,
	Sellerform,
} from "./forms";
import { CartCount, RelatedProducts } from "./context-hooks";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import CoreHttpHandler from "./http/services/CoreHttpHandler";
import Library from "./pages/Library";
import UserInterests from "./pages/UserInterests";
import DocumentsGuide from "./pages/ShareHolder Rights/DocumentsGuide";
import Videos from "./pages/ShareHolder Rights/Videos";
import Webinars from "./pages/ShareHolder Rights/Webinars";
import Faqs from "./pages/ShareHolder Rights/Faqs";
import UsefulResources from "./pages/UsefulResources";
import CompanyMeetingnAnnouncement from "./pages/E Services/CompanyMeeting&Announcement";
import Directorship from "./pages/E Services/Directorship";
import AdvisoryService from "./pages/E Services/AdvisoryService";
import UsefulResourcesCat from "./pages/UsefulResourcesCat";
import CourseInfo from "./pages/ShareHolder Education/CourseInfo";
import ResetPassword from "./forms/ResetPassword";
function AppRoutes({
	getProducts,
	sortBy,
	setSortBy,
	loading,
	setLoading,
	currentParams,
	searchPro,
	setSearchPro,
	setCurrentParams,
	products,
	searchVal,
	setSearchVal,
	totalpages,
}) {
	const [cartCount, setCartCount] = useState({
		balance: 0,
		count: 0,
		productIds: [],
		dealsIds: [],
	});
	const [show, setShow] = useState(true);

	const [ageModal, setAgeModal] = useState(true);
	const [allCarts, setAllCarts] = useState([]);
	const [relatedProducts, setRelatedProducts] = useState([]);
	const [totalItems, setTotalItems] = useState(0);
	const [totalPrice, setTotalPrice] = useState(0);
	const location = useLocation();

	let userToken = localStorage.getItem("token");

	const token = localStorage.getItem("user_token");
	const fetchCarts = () => {
		if (token) {
			CoreHttpHandler.request(
				"cart",
				"fetch",
				{},
				(response) => {
					if (response.data.data.settings) {
						setAllCarts(response.data.data.settings);
					}
				},
				(err) => {
					console.log(err);
				}
			);
		}
	};

	useEffect(() => {
		setShow(true);
		// const isUserValid = sessionStorage.getItem("isValid");
		// if (!isUserValid) {
		// 	ageValidations();
		// }
		if (!show) {
			CoreHttpHandler.request(
				"products",
				"allProducts",

				{
					limit: 50,
					page: 0,
				},
				(response) => {
					const res = response.data.data.data;
					res?.data.map((p) => {
						let avg_stars = 0;
						if (p.ratings[0].stars != null) {
							p.ratings.map((r) => {
								avg_stars += r.stars;
							});
						}
						p["avg_rating"] = avg_stars / p.ratings.length;
					});
					setRelatedProducts(res.data);
				},
				(err) => {
					console.log(err);
				}
			);
		}
		fetchCarts();

		// const ifExist = localStorage.getItem("client_token");

		// CoreHttpHandler.request(
		// 	"client",
		// 	"auth",
		// 	{},
		// 	(response) => {
		// 		const token = response.data.data.token;
		// 		setShow(false);

		// 		if (!ifExist) {
		// 			localStorage.setItem("client_token", token);
		// 		}
		// 	},
		// 	(err) => {
		// 		console.log(err, "auth error ");
		// 	}
		// );
	}, [location.pathname]);

	useEffect(() => {
		if (allCarts) {
			let allItems = 0;
			let allPrice = 0;
			let products = [];
			let deals = [];
			allCarts.map((val) => {
				allItems += val.qty;

				if (val.hot_deal_id) {
					allPrice += val.deal_price * val.qty;
				} else if (val.sale_price > 0) {
					allPrice += val.sale_price * val.qty;
				} else {
					allPrice += val.price * val.qty;
				}

				if (val.id) {
					products.push(val.id);
				} else {
					deals.push(val.hot_deal_id);
				}
			});
			setTotalItems(allItems);
			setTotalPrice(allPrice.toString().substring(0, 8));
			setCartCount({
				count: allCarts.length,
				balance: allPrice.toString().substring(0, 8),
				productIds: products,
				dealsIds: deals,
			});
		}
	}, [allCarts]);

	const searchProducts = (clear, page) => {
		let params = {
			key: "nameVal",
			value: searchVal,
			key2: "pageVal",
			value2: page ? page : 0,
		};
		if (clear) {
			setSearchPro([]);
		} else {
			setLoading(true);

			CoreHttpHandler.request(
				"products",
				"search",
				params,
				(response) => {
					const res = response.data.data;
					res?.data?.data?.map((p) => {
						let avg_stars = 0;
						if (p.ratings[0].stars != null) {
							p.ratings.map((r) => {
								avg_stars += r.stars;
							});
						}
						p["avg_rating"] = avg_stars / p.ratings.length;
					});
					setSearchPro(res);
					setLoading(false);
				},
				(err) => {
					console.log(err);
					setLoading(false);
				}
			);
		}
	};

	return (
		<CartCount.Provider value={[cartCount, setCartCount]}>
			<RelatedProducts.Provider value={[relatedProducts, setRelatedProducts]}>
				<Header />
				<Routes>
					<Route
						path='/'
						element={
							<Home
								show={show}
								ageModal={ageModal}
								setAgeModal={setAgeModal}
								setShow={setShow}
							/>
						}
					/>
					<Route
						path='/ShareHolderEducation/learning'
						element={<Learning />}
					/>
					{/* <Route
						path='/E-service'
						element={<EService />}
					/> */}
					{/* <Route
						path='/library'
						element={
							<Library />
						}
					/> */}
					<Route
						path='/faq'
						element={<Faq />}
					/>
					<Route
						path='/contact'
						element={<Contact />}
					/>


					<Route
						path='/login'
						element={<Loginform />}
					/>

					{/* <Route
						path='/singleproduct/:id'
						element={
							<Singleproduct
								allCarts={allCarts}
								token={token}
								fetchCarts={fetchCarts}
							/>
						}
					/> */}

					{/* <Route
						path='/wishlist'
						element={<Wishlist />}
					/> */}
					<Route
						path='/Library/Legal&RegulatoryInformation/:id'
						element={<LegalnRegInfoCat />}
					/>
					<Route
						path='/Library/Legal&RegulatoryInformation/:id/:id'
						element={<LegalnRegInfoCatDetails />}
					/>
					<Route
						path='/Library/Legal&RegulatoryInformation'
						element={<LegalnRegInfo />}
					/>
					<Route
						path='/DirectorshipApplication'
						element={<DirectorshipApplication />}
					/>
					<Route
						path='/DirectorshipApplication/:id'
						element={<DirectorshipApplicationCat />}
					/>
					<Route
						path='/Library/UsefulResources'
						element={<UsefulResources />}
					/>
					<Route
						path='/Library/UsefulResources/:id'
						element={<UsefulResourcesCat />}
					/>
					<Route
						path='/Library/NewsFeeds'
						element={<NewsFeeds />}
					/>
					<Route
						path='/MyApplication'
						element={<MyApplication />}
					/>
					<Route
						path='/ShareHolderEducation/WebinarsandEvents'
						element={<WebinarsandEvents />}
					/>
					<Route
						path='/ShareHolderEducation/PICGPodcast'
						element={<PICGPodcast />}
					/>
					<Route
						path='/ShareHolderEducation/Presentation'
						element={<Presentation />}
					/>
					<Route
						path='/ShareHolderEducation/GovernanceUpdate'
						element={<GovernanceUpdate />}
					/>
					<Route
						path='/Announcements'
						element={<Announcements />}
					/>
					<Route
						path='/Proceeding'
						element={<Proceeding />}
					/>
					<Route
						path='/E-service/E-Voting'
						element={<EVoting />}
					/>
					<Route
						path='/E-service/CompanyMeeting&Announcements'
						element={<CompanyMeetingnAnnouncement />}
					/>
					<Route
						path='/E-service/Directorship'
						element={<Directorship />}
					/>
					<Route
						path='/E-service/AdvisoryServices'
						element={<AdvisoryService />}
					/>
					<Route
						path='/Library/NewsFeeds/:id'
						element={<NewsFeedsDetails />}
					/>
					<Route
						path='/ShareHolders'
						element={<ShareHolders />}
					/>
					<Route
						path='/ShareHoldersRights/Documents'
						element={<DocumentsGuide />}
					/>
					<Route
						path='/ShareHoldersRights/Videos'
						element={<Videos />}
					/>
					<Route
						path='/ShareHoldersRights/Webinars'
						element={<Webinars />}
					/>
					<Route
						path='/ShareHoldersRights/Faqs'
						element={<Faqs />}
					/>


					{/* {!token && (
						<Route
							path='/createnewpass'
							element={<Createnewpass />}
						/>
					)} */}
					{!token && (
						<Route
							path='/forgotpassword'
							element={<Forgotpassword />}
						/>
					)}
					{!token && (
						<Route
							path='/reset-password/:id'
							element={<ResetPassword />}
						/>
					)}

					{/*
					{!token && (
						<Route
							path='/registerform'
							element={<Registerform />}
						/>
					)}

					{!token && (
						<Route
							path='/verifyemail'
							element={<Verifyemail />}
						/>
					)} */}

					{/* {!token && (
						<Route
							path='/sellerform'
							element={<Sellerform />}
						/>
					)} */}

					{/* <Route
						path='/checkout'
						element={<Checkout fetchCarts={fetchCarts} />}
					/>
					<Route
						path='/cart'
						element={
							<Cart
								allCarts={allCarts}
								totalItems={totalItems}
								totalPrice={totalPrice}
								fetchCarts={fetchCarts}
							/>
						}
					/>
					<Route
						path='/singledeal/:id'
						element={
							<SingleDeal
								allCarts={allCarts}
								fetchCarts={fetchCarts}
							/>
						}
					/>
					<Route element={<ProtectedRoute />}>
						<Route
							path='/orderdetail/:id'
							element={<Orderdetail />}
						/>
					</Route> */}

					{/* <Route element={<ProtectedRoute />}>
						<Route
							path='/orderhistory'
							element={<Orderhistory />}
						/>
					</Route> */}

					{/* <Route element={<ProtectedRoute />}> */}
					{/* </Route> */}
					{/* <Route
						path='/userprofile'
						element={<Userprofile />}
					/>
					<Route
						path='/myInterests'
						element={<UserInterests />}
					/> */}
					{/* <Route
						path='/myCourses'
						element={<Courses />}
					/> */}
					{/* {userToken && */}
					<Route
						path='/myCourses/:id'
						element={<CourseInfo userToken={userToken} />}
					/>
					{/* // } */}
					<Route
						path='*'
						element={<Error />}
					/>
				</Routes>
				<Footer
					show={show}
					getProducts={getProducts}
				/>
			</RelatedProducts.Provider>
		</CartCount.Provider>
	);
}

export default AppRoutes;
